module.exports = __webpack_public_path__ + "static/media/stability_comparison.e092bb2e.mp4";